module.exports = __webpack_public_path__ + "img/development-during-recession-top.911a98d5.webp";